import {
  StackLayout,
  HeadingText,
  ParagraphText,
  Button,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';

type ButtonConfig = {
  label: string;
  onClick: () => void;
  isButtonLoading?: boolean;
  fullWidth?: boolean;
};

export type StepScreenProps = {
  headerContent?: React.ReactNode;
  heading?: string;
  subHeading?: string;
  children?: React.ReactNode;
  primaryButton: ButtonConfig;
  secondaryButton?: ButtonConfig;
  centered?: boolean;
};

export const StepScreen = ({
  headerContent,
  heading,
  subHeading,
  children,
  primaryButton,
  secondaryButton,
  centered,
}: StepScreenProps) => {
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));

  const getButtonJustification = () => {
    if (centered) return 'center';
    if (secondaryButton) return 'space-between';
    return 'flex-end';
  };

  return (
    <StackLayout
      spacing="$half"
      css={{
        alignItems: centered ? 'center' : 'flex-start',
        width: '100%',
        textAlign: centered ? 'center' : 'left',
      }}
    >
      {headerContent}

      <HeadingText level="2" size="xl">
        {heading}
      </HeadingText>

      {subHeading && (
        <ParagraphText
          css={{
            '&:not(:last-child)': {
              marginBlockEnd: '$one',
            },
          }}
        >
          {subHeading}
        </ParagraphText>
      )}

      {children}

      <StackLayout
        orientation={isMobile ? 'vertical' : 'horizontal'}
        css={{
          width: '100%',
          justifyContent: getButtonJustification(),
          gap: '$one',
          flexWrap: 'wrap-reverse',
          marginTop: '$one',
          ...(isMobile && {
            flexDirection: 'column-reverse',
          }),
        }}
      >
        {secondaryButton && (
          <Button
            priority="secondary"
            onClick={secondaryButton.onClick}
            width={isMobile ? 'fillContainer' : 'hugContents'}
            loading={secondaryButton.isButtonLoading}
          >
            {secondaryButton.label}
          </Button>
        )}
        <Button
          onClick={primaryButton.onClick}
          width={
            isMobile || primaryButton.fullWidth
              ? 'fillContainer'
              : 'hugContents'
          }
          loading={primaryButton.isButtonLoading}
        >
          {primaryButton.label}
        </Button>
      </StackLayout>
    </StackLayout>
  );
};
